import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { DsrIconsModule } from '@desyre/icons-angular';
import { MatIconModule } from '@angular/material/icon';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { InvoicesComponent } from './invoices.component';
import { InvoiceService } from './invoices.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

@NgModule({
        declarations: [InvoicesComponent],
        imports: [
                CommonModule,
                TranslateModule,
                SharedModule,
                DsrIconsModule,
                MatIconModule,
                MatProgressSpinnerModule,
                MatButtonToggleModule,
                MatChipsModule,
                FormsModule,
                MatTableModule,
                MatSelectModule,
                MatFormFieldModule
        ],
        providers: [InvoiceService, provideHttpClient(withInterceptorsFromDi())]
})

export class InvoicesModule { }